/** Download AI job text output from S3 via pdf-presigned blob API. */
export async function downloadSurfBlobText(presignedBaseUrl, getIdToken, s3Key) {
    const base = presignedBaseUrl.replace(/\/+$/, "");
    if (!base)
        throw new Error("Storage cloud non configurato per output job AI.");
    const token = await getIdToken();
    const res = await fetch(`${base}/blob/download-url`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-oidc-token": token,
        },
        body: JSON.stringify({ s3Key }),
    });
    const text = await res.text();
    if (!res.ok) {
        throw new Error(`Download URL (${res.status}): ${text.slice(0, 200)}`);
    }
    const json = JSON.parse(text);
    if (!json.url)
        throw new Error("Risposta download non valida.");
    const blobRes = await fetch(json.url);
    if (!blobRes.ok)
        throw new Error(`Download blob (${blobRes.status})`);
    const raw = (await blobRes.text()).trim();
    if (!raw)
        throw new Error("Output job AI vuoto.");
    try {
        const obj = JSON.parse(raw);
        for (const key of ["outputText", "text", "content"]) {
            const inner = obj[key];
            if (typeof inner === "string" && inner.trim())
                return inner.trim();
        }
    }
    catch {
        /* plain text from bedrock converse */
    }
    return raw;
}
